import React,{useState,useEffect}from "react";
import {notDecimals} from '../helpers/formatter'
import {ArrowUpOutlined,ArrowDownOutlined,ArrowRightOutlined,ArrowLeftOutlined,CaretUpOutlined,CaretDownOutlined} from '@ant-design/icons';
import {Empty} from 'antd';


function TableDP(props) {
    
    const data = props.data?props.data:[]
    const date = props.date
    const vsMorD = props.vsMorD
    const headers = props.headers?props.headers:[]
    const [sections, setSections] = useState([]);
    const [cols, setCols] = useState([]);
   
   
   useEffect(() => {
      
      let sectionsData = data.reduce((r,a)=>{

        let item = {visible:true}
        r[a.id_seccion] = item
        return r

      },[])

      setSections(sectionsData)
      
   }, [data]);

   useEffect(()=>{

     if (cols.length===0)
      {
        let colsData = headers.reduce((r,a)=>{

        let item = {visible:false}
            r[a.id] = item
            return r

        },[])

        setCols(colsData)
      }

   },[headers])


   function onChangeSection(id)
   {
        let items = [...sections];  
        items[id].visible =  !items[id].visible
        setSections(items)
   }

   function onChangeCol(id)
   {
        let items = [...cols];  
        items[id].visible =  !items[id].visible
        setCols(items)
   }
   
  return (
    data.length>0?
    <table className="dp-table"> 
        <thead>
            <tr>
            <th className="dp-head one dp-background-transparent"></th>
            {
                headers.map((item,index)=>{
                    
                    const isVisible = cols[item.id]?cols[item.id].visible:true

                    if (item.tipo===1)
                    {
                        return <th key={index} className="dp-head c">
                            <div className="dp-head-item" onClick={()=>onChangeCol(item.id)}>
                                <div>{item.nombre} {date}</div>
                                {isVisible?<ArrowLeftOutlined style={{marginLeft:"auto"}}/>:<ArrowRightOutlined style={{marginLeft:"auto"}}/>}
                            </div>
                        </th>
                    }else
                    {

                        return isVisible?<th key={index} className="dp-head g">
                                <div className="dp-head-item">
                                    <div>{item.nombre}</div>
                                </div>
                             </th>:null
                    }

                    
                })
            }
            </tr>
        </thead>
        <tbody>
        {  
            data.map((item,index)=>{
               
               const isVisible = sections[item.id_seccion]?sections[item.id_seccion].visible:true

               const rowMain = <tr key={index}>
                        <td className="dp-td-white-c dp-sticky-sh-one" onClick = {()=>onChangeSection(item.id_seccion)}>
                        {isVisible?<ArrowUpOutlined/>:<ArrowDownOutlined/>}{" "+item.seccion}
                        </td>
                         {headers.map((xItem,xIndex)=>{

                            const isVisibleCol = cols[xItem.id]?cols[xItem.id].visible:true
                            if (xItem.tipo===1)
                            {
                               return <td key={xIndex} className="dp-td-white dp-sticky-ssh-one main"></td>
                            }
                            else
                            {
                               return isVisibleCol?<td key={xIndex} className="dp-td-white dp-sticky-ssh-one sub"></td>:null
                            }
                            
                         })}
                      </tr>

                const rows =  item.filas.map((xItem,xIndex)=>{

                    const row = <td key={xIndex}
                                    style={{fontWeight:xItem.nivel===1?"600":"400"}} 
                                    className="dp-td-white-c dp-font-left dp-sticky-d-one" >
                                    {xItem.fila}
                                </td>
                    
                    const vals = xItem.columnas.map((yItem,yIndex)=>{

                        const isVisibleCol = cols[yItem.id_columna]?cols[yItem.id_columna].visible:true
                        if (yItem.tipo==1)
                        {
                            return  <td key = {yIndex} className="dp-td-white  dp-td-main dp-font-right">
                                    {yItem.prefijo+notDecimals.format(yItem.valor)
                                    +yItem.subfijo+(yItem.prefijo_sub==='|'?' | ':'')
                                    +(yItem.prefijo_sub==="|"?notDecimals.format(yItem.sub_valor):"")
                                    +yItem.subfijo_sub}{yItem.analisis===-1?<CaretDownOutlined style={{color:"#DC143C",marginLeft:"5px"}}/>:
                                    (yItem.analisis===1?<CaretUpOutlined style={{color:"#4CBB17",marginLeft:"5px"}}/>:null) }
                                </td>
                        }else
                        {
                            return  isVisibleCol?<td key = {yIndex} className="dp-td-white dp-font-right">
                                    {yItem.prefijo+notDecimals.format(yItem.valor)
                                    +yItem.subfijo+(yItem.prefijo_sub==='|'?' | ':'')
                                    +(yItem.prefijo_sub==="|"?notDecimals.format(yItem.sub_valor):"")
                                    +yItem.subfijo_sub}
                                </td>:null
                        }
                        
                    })
                    return <tr key={xIndex}>
                                {
                                    (xItem.dia === 0 && vsMorD === 1) ? null : [xItem.nivel===1?row:isVisible?row:null, xItem.nivel===1?vals:isVisible?vals:null]
                                }
                           </tr>
                })

                return [rowMain,rows]

            })
        }
        </tbody>
    </table>:
    <Empty 
      className = "dp-chart-empty"
      image={Empty.PRESENTED_IMAGE_SIMPLE} 
      description="Click en consultar para ver la información" />
    )
}

export default TableDP;